
.kit-playground {
  color: var(--color-primary);
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    sans-serif;

  --kit-frame-bg: var(--background-primary);
  --kit-stage-bg: var(--background-primary);
  --kit-panel-bg: var(--background-primary);
  --kit-soft-bg: var(--background-secondary);
  --kit-border: var(--color-border);
  --kit-text: var(--color-primary);
  --kit-muted: var(--color-secondary);
  --kit-accent: var(--accent);
}

.kit-playground__footer button,
.kit-playground button,
.kit-playground input,
.kit-playground select {
  font: inherit;
}

.kit-playground--error {
  padding: 16px;
  border: 1px solid var(--kit-border);
  border-radius: 12px;
  background: var(--kit-soft-bg);
  color: #ff444f;
  font-size: 14px;
}

.kit-playground__frame {
  overflow: hidden;
  border: 1px solid var(--kit-border);
  border-radius: 18px;
  background: var(--kit-soft-bg);
}

.kit-playground__stage {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 250px;
  padding: 8px;
  background: var(--kit-stage-bg);
  overflow: visible;
}

.kit-playground__viewport {
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: center;
  transition: transform 150ms ease;
  width: 375px;
  max-width: 100%;
}

.kit-playground__item{
  display: flex;
  align-items: center;
  justify-content: center;
  background: inherit;
  overflow: visible;
  width: 100%;
  min-height: 100%;
}

.kit-playground__item a,
.kit-playground__item a:link,
.kit-playground__item a:visited,
.kit-playground__item a:hover,
.kit-playground__item a:active {
  color: inherit !important;
  text-decoration: none;
}


.kit-playground__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  min-height: 44px;
  padding: 0 14px;

  border-top: 1px solid var(--kit-border);
  background: var(--kit-panel-bg);
}

.kit-playground__tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kit-playground__tool-button,
.kit-playground__platform-icon {
  display: inline-grid;
  place-items: center;

  width: 22px;
  height: 22px;
  padding: 0;

  border: 0;
  border-radius: 6px;
  background: transparent;

  color: var(--kit-muted);
  cursor: pointer;

  transition:
    color 150ms ease,
    background 150ms ease;
}

.kit-playground__tool-button svg,
.kit-playground__platform-icon svg {
  width: 18px;
  height: 18px;
}

.kit-playground__tool-button:hover,
.kit-playground__platform-icon:hover {
  background: transparent;
  color: var(--kit-text);
}

.kit-playground__platform-icon[aria-pressed="true"] {
  color: var(--kit-accent);
}

.kit-playground__platform-slash{
  opacity: 0.5;
}

.kit-playground__platform-group {
  display: flex;
  align-items: center;
  gap: 2px;
}

.kit-playground__zoom {
  min-width: 48px;
  color: var(--kit-text);
  font-size: 14px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  text-align: center;
}

/* Slash between Android and iOS icons */
.kit-playground__platform-icon + .kit-playground__platform-icon {
  position: relative;
  margin-left: 14px;
}

.kit-playground__divider {
  display: none;
}

/* Legacy classes safety */
.kit-playground__icon-button,
.kit-playground__platform {
  display: inline-grid;
  place-items: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--kit-muted);
  cursor: pointer;
}

.kit-playground__icon-button:hover,
.kit-playground__platform:hover,
.kit-playground__platform[aria-pressed="true"] {
  color: var(--kit-accent);
}

/* Show code button */

.kit-playground__show-code {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  padding: 0;
  border: 0;
  background: transparent;

  color: var(--kit-accent);
  font-size: 20px;
  line-height: 1;

  cursor: pointer;
  transition:
    color 150ms ease,
    opacity 150ms ease;
}

.kit-playground__show-code:hover {
  opacity: 0.85;
}

.kit-playground__show-code span {
  display: inline-block;
  font-size: 28px;
  line-height: 0.7;
  transition: transform 180ms ease;
}

.kit-playground__show-code[aria-expanded="true"] span {
  transform: rotate(90deg);
}

.kit-playground__chevron {
  width: 16px;
  height: 16px;
  transition: transform 180ms ease;
}

.kit-playground__show-code[aria-expanded="true"] .kit-playground__chevron {
  transform: rotate(90deg);
}

/* Code block inside playground frame */

.kit-playground__code {
  border-top: 1px solid var(--kit-border);
  background: var(--kit-soft-bg);
}

.kit-playground__code pre {
  margin: 16px;
  overflow: auto;
}

.kit-playground__code code {
  color: color-mix(in srgb, var(--kit-accent) 55%, var(--kit-text));
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Monaco,
    Consolas,
    "Liberation Mono",
    "Courier New",
    monospace;
  font-size: 21px;
  line-height: 1.45;
}

/* Props table */

.kit-props {
  margin-top: 14px;
  overflow: hidden;

  border: 1px solid var(--kit-border);
  border-radius: 16px;
  background: var(--kit-frame-bg);

  --kit-props-col-1: 160px;
  --kit-props-col-2: minmax(280px, 1fr);
  --kit-props-col-3: 240px;
}

.kit-props__head,
.kit-props__row {
  display: grid;
  grid-template-columns:
    var(--kit-props-col-1)
    var(--kit-props-col-2)
    var(--kit-props-col-3);
  align-items: baseline;
}

.kit-props__head {
  min-height: 44px;
  border-bottom: 1px solid var(--kit-border);
  background: var(--kit-soft-bg);
}

.kit-props__head > div {
  display: flex;
  align-items: center;
  min-height: inherit;
  min-width: 0;
  padding: 0 14px;

  color: var(--kit-muted);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}

.kit-props__row {
  background: var(--kit-frame-bg);
}

.kit-props__row:not(:last-child) {
  border-bottom: 1px solid var(--kit-border);
}

.kit-props__row > div {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 10px 14px;
}

/* No vertical column borders */
.kit-props__head > div,
.kit-props__row > div {
  border-right: 0 !important;
}

.kit-props__name {
  color: var(--kit-text);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.25;
}

.kit-props__type {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 6px;
  justify-content: flex-start;
}

.kit-props__type code {
  display: inline-flex;
  align-items: center;

  padding: 2px 8px;
  border-radius: 5px;

  background: var(--kit-soft-bg);
  color: var(--kit-text);

  white-space: nowrap;

  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Monaco,
    Consolas,
    monospace;
  font-size: 15px;
  line-height: 1;
}

.kit-segmented {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;

  width: 100%;
  height: 36px;
  padding: 4px;

  border-radius: 12px;
  background: var(--kit-soft-bg);
  overflow: hidden;
}

.kit-segmented::before {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;

  width: calc((100% - 8px) / 2);
  height: calc(100% - 8px);

  border-radius: 8px;
  background: var(--background-primary);

  transform: translateX(0);
  transition: transform 180ms ease;
}

.kit-segmented:has(button:nth-child(2)[aria-pressed="true"])::before {
  transform: translateX(100%);
}

.kit-segmented button {
  position: relative;
  z-index: 1;

  min-width: 0;
  min-height: 0;
  padding: 0;

  border: 0;
  border-radius: 8px;
  background: transparent !important;

  color: var(--kit-text);
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  line-height: 1;

  cursor: pointer;
}

.kit-segmented button:hover,
.kit-segmented button:hover:not([aria-pressed="true"]) {
  color: var(--kit-text);
}

.kit-segmented button[aria-pressed="true"] {
  background: transparent !important;
  color: var(--kit-text);
}

.kit-input {
  width: 100%;
  max-width: 280px;
  padding: 9px 12px;

  border-radius: 8px;
  background: var(--kit-soft-bg);
  color: var(--kit-text);

  font-family: inherit;
  font-size: 16px;

  outline: none;
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease;
}

.kit-input:focus {
  border-color: var(--kit-accent);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--kit-accent) 20%, transparent);
}

/* Radio group для enum-параметров */

.kit-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kit-radio-group label {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  line-height: 1;
  color: var(--kit-text);

  cursor: pointer;
  user-select: none;
}

.kit-radio-group input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  margin: 0;

  width: 22px;
  height: 22px;

  border: 2px solid var(--kit-border);
  border-radius: 50%;
  background: transparent;

  cursor: pointer;
  transition:
    border-color 150ms ease,
    background 150ms ease,
    box-shadow 150ms ease;
}

.kit-radio-group input[type="radio"]:checked {
  border-color: var(--kit-accent);
  background: var(--kit-accent);
  box-shadow: inset 0 0 0 5px var(--kit-frame-bg);
}

.kit-radio-group input[type="radio"]:hover:not(:checked) {
  border-color: var(--kit-muted);
}

/* Select controls for string-enum параметров */

.kit-select {
  display: block;
  width: 100%;
  max-width: 100%;
  min-height: 40px;
  padding: 6px 40px 6px 12px;

  border: none;
  border-radius: 8px;
  background: var(--kit-soft-bg);
  color: var(--kit-text);

  font-family: inherit;
  font-size: 16px;

  appearance: none;
  -webkit-appearance: none;

  outline: none;
  cursor: pointer;
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease;

  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23888' d='M5.47 8.53a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 0 0-1.06-1.06L6 6.94 3.03 3.97a.75.75 0 0 0-1.06 1.06l3.5 3.5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
}

.kit-select:focus {
  border-color: var(--kit-accent);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--kit-accent) 20%, transparent);
}

/* Text controls for future examples */

.kit-static-value{
  color: var(--kit-text);
  font-size: 14px;
  line-height: 1;
}

@media (max-width: 760px) {
  .kit-playground__stage {
    min-height: 260px;
    padding: 32px 16px;
  }

  .kit-playground__footer {
    align-items: stretch;
    flex-direction: column;
    gap: 14px;
    padding: 16px;
  }

  .kit-playground__tools {
    flex-wrap: wrap;
  }

  .kit-props {
    --kit-props-col-1: 1fr;
    --kit-props-col-2: 1fr;
    --kit-props-col-3: 1fr;
  }

  .kit-props__head {
    display: none;
  }

  .kit-props__row {
    grid-template-columns: 1fr;
    gap: 8px;
    min-height: auto;
    padding: 14px 16px;
  }

  .kit-props__row > div {
    min-height: auto;
    padding: 0;
  }

  .kit-props__control {
    justify-content: flex-start;
  }
}